export default __webpack_public_path__ + "static/media/107.6b11bcfd.jpg";